import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
    fullName: Yup.string()
        .min(2, 'Full name must be at least 2 characters')
        .max(100, 'Full name must be less than 100 characters')
        .required('Full name is required'),
    email: Yup.string()
        .email('Invalid email format')
        .required('Email is required'),
    telephone: Yup.string()
        .matches(
            /^[0-9+\-\s()]+$/,
            'Invalid telephone number format. Only numbers, spaces, +, -, and () are allowed'
        )
        .min(10, 'Telephone number must be at least 10 digits')
        .max(20, 'Telephone number must be less than 20 characters')
        .required('Phone number is required'),
    message: Yup.string()
        .min(10, 'Message must be at least 10 characters')
        .max(1000, 'Message must be less than 1000 characters')
        .required('Message is required'),
});

export default validationSchema;
